import { useLang } from '@/i18n';
import { getSolarRecommand } from '@/service/solar-calculator';
import gtm from '@/utils/gtm';
import FormatCurrencyLocal from 'eco-design-reliance/currency/FormatCurrencyLocal';
import EcoImg from 'eco-design/base/eco-img';
import EcoLink from 'eco-design/base/eco-link';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import css from './index.module.scss';

const C: React.FC = () => {
    const { locale = '' } = useRouter();
    const { t } = useLang('theProduct.ProductBundle');
    const [active, setActive] = useState<number>(0);
    const tabs: string[] = [t('C_tab1'), t('C_tab2')];
    const [items, setItems] = useState([[]]);
    const products_static: any[] = [
        {
            title: t('C_item1_title'),
            desc: t('C_item1_desc'),
            subs: [
                {
                    name: t('C_item1_list1_name'),
                    text: t('C_item1_list1_desc'),
                },
                {
                    name: t('C_item1_list2_name'),
                    text: t('C_item1_list2_desc'),
                },
                {
                    name: t('C_item1_list3_name'),
                    text: t('C_item1_list3_desc'),
                },
            ],
            hoverImgPC: 'https://websiteoss.ecoflow.com/upload/image/1754362897208/5-pc.jpg',
            hoverImgPad: 'https://websiteoss.ecoflow.com/upload/image/1754362895845/5-h5.jpg',
            productId: (() => {
                const map: any = {
                    eu: '10000451273047',
                    uk: '9877313028435',
                    de: '15171608871293',
                    fr: '9867284775259',
                    it: '14908494086520',
                    es: '9867268227419',
                };
                return map[locale] || undefined;
            })(),
            variantId: (() => {
                const map: any = {
                    eu: '50510963605847',
                    uk: '50839544365395',
                    de: '55835191804285',
                    fr: '50473476751707',
                    it: '55029657862520',
                    es: '50473428779355',
                };
                return map[locale] || undefined;
            })(),
            link_more: `https://${locale}.ecoflow.com/products/stream-ac-pro-ac`,
        },
        {
            title: t('C_item3_title'),
            desc: t('C_item3_desc'),
            subs: [
                {
                    name: t('C_item3_list1_name'),
                    text: t('C_item3_list1_desc'),
                },
                {
                    name: t('C_item3_list2_name'),
                    text: t('C_item3_list2_desc'),
                },
                {
                    name: t('C_item3_list3_name'),
                    text: t('C_item3_list3_desc'),
                },
            ],
            hoverImgPC:
                locale === 'uk'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1762136854422/1-pc-uk.jpg'
                    : 'https://websiteoss.ecoflow.com/upload/image/1754362894351/1-pc.jpg',
            hoverImgPad:
                locale === 'uk'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1762136901806/1-m-uk.jpg'
                    : 'https://websiteoss.ecoflow.com/upload/image/1754362896157/1-h5.jpg',
            productId: (() => {
                const map: any = {
                    eu: '10190226882903',
                    uk: '10015518458195',
                    de: '15391692128637',
                    fr: '10018948874587',
                    it: '14945864352120',
                    es: '10018948415835',
                };
                return map[locale] || undefined;
            })(),
            variantId: (() => {
                const map: any = {
                    eu: '51386400244055',
                    uk: '51563639505235',
                    de: '56505715753341',
                    fr: '51022759493979',
                    it: '55213096763768',
                    es: '51022780367195',
                };
                return map[locale] || undefined;
            })(),
            link_more: `https://${locale}.ecoflow.com/products/stream-ultra-x`,
        },
        {
            title: t('C_item4_title'),
            desc: t('C_item4_desc'),
            subs: [
                {
                    name: t('C_item4_list1_name'),
                    text: t('C_item4_list1_desc'),
                },
                {
                    name: t('C_item4_list2_name'),
                    text: t('C_item4_list2_desc'),
                },
            ],
            hoverImgPC: 'https://websiteoss.ecoflow.com/upload/image/1754362896706/2-pc.jpg',
            hoverImgPad: 'https://websiteoss.ecoflow.com/upload/image/1754362895688/2-h5.jpg',
            productId: (() => {
                const map: any = {
                    eu: '10000451273047',
                    uk: '9877313028435',
                    de: '15171608871293',
                    fr: '9867284775259',
                    it: '14908494086520',
                    es: '9867268227419',
                };
                return map[locale] || undefined;
            })(),
            variantId: (() => {
                const map: any = {
                    eu: '50511130329431',
                    uk: '50839544398163',
                    de: '55835191837053',
                    fr: '50473476784475',
                    it: '55029657895288',
                    es: '50473428812123',
                };
                return map[locale] || undefined;
            })(),
            link_more: `https://${locale}.ecoflow.com/products/stream-ac-pro-ac`,
        },
        {
            title: t('C_item6_title'),
            desc: t('C_item6_desc'),
            subs: [
                {
                    name: t('C_item6_list1_name'),
                    text: t('C_item6_list1_desc'),
                },
                {
                    name: t('C_item6_list2_name'),
                    text: t('C_item6_list2_desc'),
                },
                {
                    name: t('C_item6_list3_name'),
                    text: t('C_item6_list3_desc'),
                },
            ],
            hoverImgPC: 'https://websiteoss.ecoflow.com/upload/image/1754362896981/4-pc.jpg',
            hoverImgPad: 'https://websiteoss.ecoflow.com/upload/image/1754362895202/4-h5.jpg',
            productId: (() => {
                const map: any = {
                    eu: '10000451273047',
                    uk: '9877313028435',
                    de: '15171608871293',
                    fr: '9867284775259',
                    it: '14908494086520',
                    es: '9867268227419',
                };
                return map[locale] || undefined;
            })(),
            variantId: (() => {
                const map: any = {
                    eu: '51933314580823',
                    uk: '50839544463699',
                    de: '56436744946045',
                    fr: '50473476850011',
                    it: '55029657960824',
                    es: '50473428877659',
                };
                return map[locale] || undefined;
            })(),
            link_more: `https://${locale}.ecoflow.com/products/stream-ac-pro-ac`,
        },
    ];
    const [gap, setGap] = useState<number>(12);

    const handleClickTab = (tab: string, k: number) => {
        setActive(k);
        gtm.push({
            event: 'uaEvent',
            event_name: 'tab_click',
            list_name: 'none',
            button_name: tab,
        });
    };

    const getAsynItem = async (item: any) => {
        const { productId, variantId } = item;
        return await new Promise(async (resolve, reject) => {
            try {
                const res = await getSolarRecommand({ productId, variantId }, locale);
                if (res?.code === '0') {
                    item.price = res?.data?.price;
                    item.compareAtPrice = res?.data?.compareAtPrice || res?.data?.price;
                    // item.link_more = res?.data?.handle ? `https://${locale}.ecoflow.com/${res?.data?.handle}` : '';
                    item.img = item?.img || res?.data?.variantImg || res?.data?.img;
                    item.link_more = `${item.link_more}?variant=${item.variantId}`;
                    return resolve(res);
                } else {
                    console.error(res?.message);
                    return reject(res?.message);
                }
            } catch (e) {
                console.error(e);
                return reject(e);
            }
        });
    };

    useEffect(() => {
        const arr = JSON.parse(JSON.stringify(products_static));
        const promises = arr?.map((item: any) => getAsynItem(item));
        Promise.all(promises)
            .then(() => {
                let a1 = arr.slice(0, 1);
                let a2 = arr.slice(1);

                if (locale === 'fr') {
                    a1 = arr.slice(0, 1);
                    a2 = arr.slice(1);
                }
                setItems([a1, a2]);
            })
            .catch((e) => {
                console.error(e);
            });

        if (typeof window !== 'undefined') {
            setGap(window.innerWidth > 1024 ? 24 : 12);
        }
    }, []);

    return (
        <section className={`${css.section} stream-extra-battery-C`} id="stream-extra-battery-C">
            <div className="tabs-box">
                <ul className="tabs">
                    {tabs?.map((tab: string, k: number) => (
                        <li className={`tab${active === k ? ' active' : ''}`} key={tab} onClick={() => handleClickTab(tab, k)}>
                            {tab}
                        </li>
                    ))}
                </ul>
            </div>
            <ul className="swipers">
                {items?.map((lists: any[], m: number) => (
                    <li className={`swiper-box swiper-box-${m + 1}${m === active ? ' active' : ''}`} key={m}>
                        <Swiper className="items" modules={[Navigation]} spaceBetween={gap} slidesPerView={'auto'} initialSlide={0} navigation={true}>
                            {lists?.map((item: any, k: number) => (
                                <SwiperSlide className={`item item-${k + 1}`} key={`${m}_${k}`}>
                                    <div className="item-img">
                                        <EcoImg className="img-p" pc={item.img} />
                                        <EcoImg className="img-h" pc={item.hoverImgPC} pad={item.hoverImgPad} h5={item.hoverImgPad} />
                                    </div>
                                    <div className="item-info">
                                        <div className="item-common">
                                            <p className="item-title">{item.title}</p>
                                            <p className="item-desc">{item.desc}</p>
                                            <ul className="item-subs">
                                                {item.subs?.map((sub: any, n: number) => (
                                                    <li className="item-sub" key={`${m}_${k}_${n}`}>
                                                        <p className="item-sub-name">{sub.name}</p>
                                                        <p className="item-sub-text">{sub.text}</p>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                        <div className="item-action">
                                            <div className="item-price">
                                                {item?.price > 0 && <span className="price-price">{FormatCurrencyLocal(item.price, locale)}</span>}
                                                {item?.price > 0 && item?.compareAtPrice && item?.price !== item?.compareAtPrice && (
                                                    <span className="price-compare">{FormatCurrencyLocal(item.compareAtPrice, locale)}</span>
                                                )}
                                            </div>
                                            <EcoLink
                                                className="item-link"
                                                href={item?.link_more}
                                                dataLayer={{
                                                    event: 'uaEvent',
                                                    event_name: 'buy',
                                                    product_name: item?.title,
                                                    position: 'Product Detail_STREAM Ultra Series',
                                                }}
                                            >
                                                {t('C_learn_more')}
                                            </EcoLink>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </li>
                ))}
            </ul>
            <EcoLink
                className="option"
                href={`/${locale}/stream-series-energy-saving-calculator`}
                dataLayer={{
                    event: 'uaEvent',
                    event_name: 'jump_button',
                    position: 'STREAM Ultra Series',
                    button_name: t('C_tip'),
                    url: `https://www.ecoflow.com/${locale}/stream-series-energy-saving-calculator`,
                }}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
                    <path
                        d="M13.0162 4.57129H7.13258C5.9943 4.57129 5.07153 5.49405 5.07153 6.63234V12.516C5.07153 13.6543 5.9943 14.577 7.13258 14.577H13.0162C14.1545 14.577 15.0772 13.6543 15.0772 12.516V6.63234C15.0772 5.49405 14.1545 4.57129 13.0162 4.57129Z"
                        stroke="black"
                        strokeWidth="1.82857"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M13.0162 17.4199H7.13258C5.9943 17.4199 5.07153 18.3427 5.07153 19.481V25.3646C5.07153 26.5029 5.9943 27.4256 7.13258 27.4256H13.0162C14.1545 27.4256 15.0772 26.5029 15.0772 25.3646V19.481C15.0772 18.3427 14.1545 17.4199 13.0162 17.4199Z"
                        stroke="black"
                        strokeWidth="1.82857"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M25.8197 4.57129H19.936C18.7977 4.57129 17.875 5.49405 17.875 6.63234V12.516C17.875 13.6543 18.7977 14.577 19.936 14.577H25.8197C26.958 14.577 27.8807 13.6543 27.8807 12.516V6.63234C27.8807 5.49405 26.958 4.57129 25.8197 4.57129Z"
                        stroke="black"
                        strokeWidth="1.82857"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M25.8688 17.4199H19.9851C18.8468 17.4199 17.9241 18.3427 17.9241 19.481V25.3646C17.9241 26.5029 18.8468 27.4256 19.9851 27.4256H25.8688C27.007 27.4256 27.9298 26.5029 27.9298 25.3646V19.481C27.9298 18.3427 27.007 17.4199 25.8688 17.4199Z"
                        stroke="black"
                        strokeWidth="1.82857"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M8.25903 9.51955L9.5079 10.7684L11.8866 8.38965"
                        stroke="black"
                        strokeWidth="1.82857"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
                <span>{t('C_tip')}</span>
            </EcoLink>
        </section>
    );
};

export default C;
